<template>
  <div class="historyScore">
    <div class="contrast">
        <div class="title">
            <div class="img img1">
                <p>与历届对比未出现的比分</p>
            </div>
        </div>
        <div class="score">
            <div v-if="turnData.score_diff">
                <p v-for="(v,k,i) in turnData.score_diff" :key="i">{{k}}</p>
            </div>
            <p class="text" v-else>暂无数据</p>
        </div>
    </div>
    <div class="contrast">
        <div class="title">
            <div class="img img2">
                <p>本届已出比分（已完{{turnData.current.total}}场）</p>
            </div>
        </div>
        <div class="scoreTwo">
            <div v-if="turnData.current.list">
                <p v-for="(v,k,i) in turnData.current.list" :key="i">
                    <span>{{k}}</span>
                    <span>{{v}}场</span>
                </p>
            </div>
            <p class="text" v-else>暂无数据</p>
        </div>
    </div>
    <div class="contrast">
        <div class="title">
            <div class="img img2">
                <p>近3届出现比分（共{{turnData.history.total}}场）</p>
            </div>
        </div>
        <div class="scoreTwo">
            <div v-if="turnData.score_diff">
                <p v-for="(v,k,i) in turnData.history.list" :key="i">
                    <span>{{k}}</span>
                    <span>{{v}}场</span>
                </p>
            </div>
            <p class="text" v-else>暂无数据</p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['turnData'],
    name: 'historyScore'
}
</script>

<style lang="less" scoped>
.historyScore {
    padding: 40/2px 20/2px;
    .contrast {
        background: #FFFFFF;
        border-radius: 4/2px;
        position: relative;
        padding: 0 24/2px;
        padding-top: 60/2px;
        padding-bottom: 6/2px;
        margin-bottom: 40/2px;
        border: 1/2px solid rgba(99,122,133,0.4);
        &:last-child {
            margin: 0 auto;
            margin-bottom: 0;
        }
        .text {
            width: 100%;
            height: 60/2px;
            line-height: 60/2px;
            text-align: center;
            color: #666666;
        }
        .title {
            width: 100%;
            height: 72/2px;
            display: flex;
            justify-content: center;
            position: absolute;
            top: -24/2px;
            left: 0;
            .img {
                width: max-content;
                height: 72/2px;
                // background-image: url('../../assets/img/worldCup/historyCompare/tabBan2.png');
                background-repeat: no-repeat;
                background-size: 100% 100%;
                padding: 0 10/2px;
                p {
                    font-size: 26/2px;
                    font-weight: 400;
                    color: #F1F3FF;
                    line-height: 68/2px;
                }
            }
            .img1{
                background-image: url(../../../assets/img/activity/cup/tabBan2.png);
            }
            .img2{
                background-image: url("../../../assets/img/activity/cup/tabBan1.png");
            }
        }
        .score {
            div {
                display: flex;
                flex-wrap: wrap;
                p {
                    width: 46px;
                    height: 64/2px;
                    font-size: 32/2px;
                    font-weight: 400;
                    color: #1A313C;
                    line-height: 70/2px;
                    background: #F7FBFF;
                    margin-right: 20/2px;
                    margin-bottom: 10/2px;
                    border-radius: 4px;
                    &:nth-child(6n) {
                        margin-right: 0;
                        // margin-bottom: 0/2px;
                    }
                }
            }
        }
        .scoreTwo {
            div {
                display: flex;
                flex-wrap: wrap;
                p {
                    width: 46px;
                    height: 96/2px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    background: #F4F8FB;
                    margin-right: 20/2px;
                    margin-bottom: 10/2px;
                    &:nth-child(6n) {
                        margin-right: 0/2px;
                        // margin-bottom: 0/2px;
                    }
                    span {
                        display: block;
                        &:first-child {
                            font-size: 32/2px;
                            font-weight: 400;
                            color: #1A313C;
                        }
                        &:last-child {
                            font-size: 28/2px;
                            font-weight: 400;
                            color: #637A85;
                        }
                    }
                }
            }
        }
    }
}
</style>
